import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function usePublishersColumns() {
	const { t } = useTranslation();

	return useMemo(
		() => [
			{
				id: "name",
				filter: "text",
				Header: t("name"),
				Cell: ({ row, value }) => <Link to={`../../publishers/${row.original.id}`}>{value}</Link>,
			},
		],
		[t],
	);
}
